<template>
  <div>
    <div>
      <v-tabs
        v-model="tabs"
        background-color="transparent"
        class="border-bottom theme-light v-card"
      >
        <v-tab v-for="(item, i) in items" :key="i">{{ item.tabName }}</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tabs">
        <v-card flat>
          <v-card-text>
            <div>
              <report-inappropriate :tabs="tabs" />
            </div>
          </v-card-text>
        </v-card>
      </v-tabs-items>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
const ReportInappropriate = () =>
  import("@/components/ReportInappropriateList");
export default {
  data() {
    return {
      tabs: null,
      items: [
        { tabName: "Patient" },
        { tabName: "Doctor" },
        { tabName: "Pharmacy" },
        { tabName: "Diagnostics" },
        { tabName: "Bloodbank" },
        { tabName: "Ambulance" }
      ]
    };
  },

  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  components: {
    "report-inappropriate": ReportInappropriate
  }
};
</script>




